import { useState, useCallback } from 'react'
import { useIsMobile } from '@/hooks/ui/useIsMobile'

/**
 * Shared state and interactions for browse grids (cards, sealed products).
 * Handles mobile detection and action sheet state.
 */
export function useGridInteractions<T>() {
  const isMobile = useIsMobile()
  const [actionSheetItem, setActionSheetItem] = useState<T | null>(null)

  const handleItemClick = useCallback(
    (e: React.MouseEvent, item: T) => {
      if (isMobile) {
        e.preventDefault()
        setActionSheetItem(item)
      }
    },
    [isMobile],
  )

  const closeActionSheet = useCallback(() => setActionSheetItem(null), [])

  return {
    isMobile,
    actionSheetItem,
    handleItemClick,
    closeActionSheet,
  }
}
